/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { loaderViewNew as LoaderViewNew } from '../../shared/loaderViewNew';
import Pagination from '../../common/pagination/globalPaginationComponent';
import Modal from 'react-bootstrap/Modal';

export const viewGenAIView = (props) => {
  const {
    // onChange,
    showRequirement,
    parsedRequirement,
    requirementRadio,
    openModalData,
    onEditClicked,
    // onDeleteClicked,
    isLoading,
    totalRecords,
    currentPage,
    pageLimit,
    openModal,
    closePopup,
    modalData
  } = props;
  const TestCheck = sessionStorage.getItem('TestCheck');
  let view = null;
  if (isLoading) {
    view = <LoaderViewNew />;
  } else {
    view = (
      <div className='superAdmin__container'>
        <Modal
          show={openModal}
          onHide={closePopup}
          size='m'
          dialogClassName='modal-customw'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <div className='card login-form'>
              <div className='card-body'>{modalData}</div>
            </div>
          </Modal.Body>
        </Modal>
        {showRequirement ? (
          <div className='row'>
            <div className='center-align-div'>
              <div className='mb-3'>
                <h3 className='heading heading__level2 mb-4'>
                  {TestCheck === 'TestData'
                    ? 'View Test Data'
                    : 'View Test Cases'}
                </h3>
                <hr />
                {/* {TestDataManagement === 'true' && TestDesign === 'true' ? (
                  <div key={'app_new'} className='row mt-2 mb-2'>
                    <div className='form-group'>
                      <div className='form-check form-check-inline'>
                        <label className='heading__level5 form-check-label'>
                          Test Data Generation
                        </label>
                        <input
                          type='radio'
                          value='TestData'
                          name='requirementRadio'
                          defaultChecked={requirementRadio === 'TestData'}
                          onChange={(eve) =>
                            onChange({
                              eve,
                              id: 'requirementRadio',
                              value: eve.target.value
                            })
                          }
                          className='form-check-input'
                        />
                      </div>
                      <div className='form-check form-check-inline'>
                        <label className='heading__level5 form-check-label'>
                          Test Design
                        </label>
                        <input
                          type='radio'
                          value='TestDesign'
                          name='requirementRadio'
                          className='form-check-input'
                          onChange={(eve) =>
                            onChange({
                              eve,
                              id: 'requirementRadio',
                              value: eve.target.value
                            })
                          }
                          defaultChecked={requirementRadio === 'TestDesign'}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  ''
                )} */}
              </div>
              <table className='table table-bordered table-fit'>
                <thead className='thead-light'>
                  <tr>
                    {requirementRadio === 'TestData' ? (
                      <>
                        <th>Data Definition</th>
                        <th>DB</th>
                        <th>Data Validation</th>
                        <th>Test Data</th>
                      </>
                    ) : (
                      <>
                        <th>Requirement Description</th>
                        <th>Jira ID</th>
                        <th>Business Rules</th>
                        <th>Test Scenario</th>
                        <th>Automation Code</th>
                        <th>Action</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className='table__body'>
                  {parsedRequirement?.map((item, index) => {
                    return (
                      <tr key={index}>
                        {requirementRadio === 'TestData' ? (
                          <>
                            <td className='testdata'>
                              <a
                                onClick={() =>
                                  openModalData(item.testGenSchema)
                                }
                              >
                                {item.testGenSchema}
                              </a>
                            </td>
                            <td className='testdata'>{item.dbType}</td>
                            <td className='testdata'>{item.dataValidation}</td>
                            <td className='testdata'>
                              <a
                                onClick={() => openModalData(item.testGenData)}
                              >
                                {item.testGenData}
                              </a>
                            </td>
                          </>
                        ) : (
                          <>
                            <td className='testdesign'>
                              <a
                                onClick={() => openModalData(item.requirement)}
                              >
                                {item.requirement}
                              </a>
                            </td>
                            <td className='testdesign'>{item.jiraId}</td>
                            <td className='testdesign'>
                              <a
                                onClick={() =>
                                  openModalData(item.businessRules)
                                }
                              >
                                {item.businessRules}
                              </a>
                            </td>
                            <td className='testdesign'>
                              <a onClick={() => openModalData(item.tcScenario)}>
                                {item.tcScenario}
                              </a>
                            </td>
                            <td className='testdesign'>
                              <a onClick={() => openModalData(item.tcCode)}>
                                {item.tcCode}
                              </a>
                            </td>
                            <td className='table__row__td--superactions testdesign'>
                              <a
                                title='Edit'
                                className='mx-3'
                                onClick={(eve) => onEditClicked(eve, item)}
                              >
                                <i className='fa fa-pencil' />
                              </a>
                              {/* <a
                                title='Delete'
                                className='mx-3'
                                onClick={(eve) => onDeleteClicked(eve, item)}
                              >
                                <i className='fa fa-trash ' />
                              </a> */}
                            </td>
                          </>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination
                data={parsedRequirement}
                totalRecords={totalRecords}
                currentPage={currentPage}
                pageLimit={pageLimit}
                changeData={(e, currentPage, pageLimit) =>
                  props.changeData(e, currentPage, pageLimit)
                }
              />
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
  return <div className='page--superAdmin'>{view}</div>;
};
